import React from 'react';
import {Outlet} from 'react-router-dom';
import {AuthProvider} from '../core/AuthContext';
import {UserProvider} from '../core/UserContext';

const PrivateLayout: React.FC = () => {
    return (
        <AuthProvider>
            <UserProvider>
                <Outlet/>
            </UserProvider>
        </AuthProvider>
    );
};

export default PrivateLayout;
